<div class="association-picker phone-number-picker less-form-field-padding">
  <div>
    <div class="title">
      Telefoonnummer
      {{ phoneNumberWithOptions.ipBoardPartPhoneNumber.company.regularName }}
    </div>
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Telefoonnummer"
        [(ngModel)]="selectedPhoneNumberOption"
        [compareWith]="compareOptions"
        (selectionChange)="selectedPhoneNumberOptionChanged()"
      >
        <mat-option
          *ngFor="let option of phoneNumberWithOptions.options"
          [value]="option"
          >{{ option.label }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
  <div
    *ngIf="selectedPhoneNumberOption?.id === OTHER_PHONE_NUMBER_OPTION_ID"
    class="other-phonenumber-input"
  >
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="Gewenste telnr"
        [(ngModel)]="phoneNumberWithOptions.ipBoardPartPhoneNumber.phoneNumber"
        (ngModelChange)="save.emit()"
      />
    </mat-form-field>
  </div>
</div>
